//the connect utility helps us map the state to react component's props
import { connect } from 'react-redux';

import app from './app.jsx';
// require('../scss/main.scss');
require('react-datepicker/dist/react-datepicker.css');

const mapStateToProps = state => {
  return {
    config: state.config,
  };
};

const AppContainer = connect(mapStateToProps)(app);

export default AppContainer;
